<template>
  <div class="core-index-page" v-loading="loading">
    <el-alert
      v-if="error"
      :title="error"
      type="warning"
      :closable="false"
      show-icon
      class="page-alert"
    />

    <AnalysisDataStatusPanel
      :payload="payload"
      :loading="loading"
      title="核心指数分析数据状态"
      subtitle="固定 7 个核心指数：日线保留长期分析窗口，5分钟保留热数据窗口；周/月由日线自动生成，15分钟和60分钟由5分钟自动生成。"
      :show-items="true"
      :show-name="true"
      @refresh="refreshData"
    />

    <el-card shadow="never" class="explain-card">
      <div slot="header" class="explain-title">核心指数数据口径</div>
      <div class="rule-grid">
        <div>
          <strong>日线</strong>
          <span>固定核心指数保留长期分析数据，采用指数原始价格口径。</span>
        </div>
        <div>
          <strong>5分钟</strong>
          <span>默认保留最近 120 个交易日，用于分钟级分析。</span>
        </div>
        <div>
          <strong>周 / 月</strong>
          <span>由日线和官方交易日历自动生成，无需单独维护。</span>
        </div>
        <div>
          <strong>15分钟 / 60分钟</strong>
          <span>由5分钟数据自动生成，无需单独维护。</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import AnalysisDataStatusPanel from '@/components/AnalysisDataStatusPanel.vue'
import { coreIndexHistoryApi, coreIndexHistoryErrorMessage } from '@/api/coreIndexHistory'

export default {
  name: 'CoreIndexHistoryLibrary',
  components: { AnalysisDataStatusPanel },
  data() {
    return {
      loading: false,
      error: '',
      payload: {}
    }
  },
  created() { this.refreshData() },
  methods: {
    async refreshData() {
      this.loading = true
      this.error = ''
      try {
        this.payload = await coreIndexHistoryApi.getAnalysisDataStatus()
      } catch (error) {
        this.payload = {}
        this.error = coreIndexHistoryErrorMessage(error, '读取核心指数分析数据状态失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.core-index-page { max-width: 1480px; margin: 0 auto; }
.page-alert { margin-bottom: 14px; }
.explain-card { margin-top: 16px; border-radius: 16px; border-color: #dfe7f2; }
.explain-title { font-size: 15px; font-weight: 700; color: #1f2937; }
.rule-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.rule-grid > div { padding: 14px; border-radius: 12px; background: #f8fbff; border: 1px solid #e8eef5; }
.rule-grid strong { display: block; color: #0f172a; }
.rule-grid span { display: block; margin-top: 6px; color: #64748b; font-size: 12px; line-height: 1.6; }
@media (max-width: 1100px) { .rule-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>